import { z } from 'zod'

export const discoverClubsSchema = z.object({
  latitude: z.coerce.number().min(-90).max(90).optional(),
  longitude: z.coerce.number().min(-180).max(180).optional(),
  city: z.string().max(100).optional(),
  radiusMi: z.coerce.number().min(1).max(100).default(25),
  genreIds: z.string().optional(), // comma-separated
  venueType: z.enum(['BOOKSTORE', 'CAFE', 'LIBRARY', 'PARK', 'HOME', 'OTHER']).optional(),
  cadence: z.enum(['WEEKLY', 'BIWEEKLY', 'MONTHLY', 'FLEXIBLE']).optional(),
  page: z.coerce.number().min(1).default(1),
  limit: z.coerce.number().min(1).max(50).default(20),
  sort: z.enum(['distance', 'members', 'recent', 'active']).default('distance'),
})

export type DiscoverClubsInput = z.infer<typeof discoverClubsSchema>
